// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1896bb4f","703":"20c6b64a","787":"a192ab15"}[chunkId] + ".chunk.js";
};